import { useParams } from "react-router-dom";
import { useLang } from "../../lib/i18n";
import { useFetch } from "../../lib/useFetch";
import { fmtDate } from "../../lib/api";

export default function NewsDetail() {
  const { id } = useParams();
  const { tr, lang } = useLang();
  const { data: n } = useFetch(`/public/news/${id}`);
  if (!n) return <div className="h-screen" />;
  return (
    <article className="container-x max-w-3xl pb-24 pt-36" data-testid="news-detail-page">
      <p className="eyebrow">{fmtDate(n.date, lang)}</p>
      <h1 className="mt-4 font-display text-4xl font-extrabold text-[#0A2540] sm:text-5xl">{tr(n, "title")}</h1>
      {n.image && <img src={n.image} alt="" className="mt-10 max-h-[520px] w-full rounded-3xl object-contain bg-slate-100" />}
      <p className="mt-10 whitespace-pre-line text-lg leading-relaxed text-slate-700">{tr(n, "body")}</p>
    </article>
  );
}
